import { useChatContext } from './ChatContext';

const useSelectedElement = () => {
    const { selectedElement, setSelectedElement } = useChatContext();
    return { selectedElement, setSelectedElement };
};

export default useSelectedElement;
